import { render, staticRenderFns } from "./refund-modal.vue?vue&type=template&id=5626571c&scoped=true&"
import script from "./refund-modal.vue?vue&type=script&lang=js&"
export * from "./refund-modal.vue?vue&type=script&lang=js&"
import style0 from "./refund-modal.vue?vue&type=style&index=0&id=5626571c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5626571c",
  null
  
)

export default component.exports